import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  hasResponse: false,
  hasError: false,
  isPaymentPending: false,
  responseStatus: null,
  errorCode: null,
  errorMessage: null,
  isRetryable: false,
}

const paymentResponseSlice = createSlice({
  initialState,
  name: 'paymentResponse',
  reducers: {
    updatePaymentPending: (state, { payload }) => {
      state.isPaymentPending = payload
    },
    updateAuthoriseResponse: (state, { payload }) => ({
      ...state,
      ...payload,
      hasResponse: true,
      hasError: false,
      isPaymentPending: false,
    }),
    authoriseError: (state, { payload }) => ({
      ...state,
      ...payload,
      hasResponse: true,
      hasError: true,
      isPaymentPending: false,
    }),
    clearAuthoriseData: state => ({
      ...state,
      hasResponse: false,
      hasError: false,
      isPaymentPending: false,
      responseStatus: null,
      errorCode: null,
      errorMessage: null,
      isRetryable: false,
    }),
  },
})

export const {
  updatePaymentPending,
  updateAuthoriseResponse,
  authoriseError,
  clearAuthoriseData,
} = paymentResponseSlice.actions

export const paymentResponseSelector = state => state.paymentResponse

export default paymentResponseSlice.reducer
